<template>
  <div class="point">
    <el-tabs type="border-card"
             @edit="handleTabsEdit"
             v-model="activetab">
      <el-tab-pane :label="item.name"
                   :name="item.title"
                   v-for="(item,index) in tabDatas"
                   :key="index"
                   :closable="item.title!=='admin'"
                   :ref="item.title">
      </el-tab-pane>
    </el-tabs>
    <div class="content"
         v-if="activetab=='admin'">
      <div class="header">
        <el-button type="primary"
                   size="mini"
                   @click="addData()"
                   style="margin-top: 15px;">新增</el-button>
      </div>
      <el-table stripe
                size='small'
                :header-cell-style="{background:'#eef1f6',padding:'1px 0px',color:'black'}"
                style="width: 100%; font-size: 12px; color: black;"
                ref="multipleTable5"
                :data="tableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                tooltip-effect="dark"
                height="calc(100% - 50px)">
        <el-table-column v-for="(item, index) in currentcloumn"
                         :key="index"
                         :prop="item.name"
                         :label="item.title"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="item.name=='title'">
              <el-link style="font-size:12px;color:black">
                <span @click="editData(scope.row)">{{ scope.row[item.name] }}</span>
              </el-link>
            </div>
            <div v-else-if="item.name=='type'">
              {{ types.filter(v=>v.row_id==scope.row[item.name])?types.filter(v=>v.row_id==scope.row[item.name])[0].name:'' }}
            </div>
            <div v-else>
              {{ scope.row[item.name] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style=" display:flex;height:23px;align-items:center">
              <el-button @click="editData(scope.row)"
                         type="text"
                         size="small"
                         style="margin-right:10px!important">编辑</el-button>
              <el-popconfirm confirm-button-text='确定'
                             cancel-button-text='取消'
                             icon="el-icon-info"
                             icon-color="red"
                             @confirm="del(scope.row)"
                             title="确定删除吗？">
                <el-button slot="reference"
                           type="text"
                           size="small">删除</el-button>
              </el-popconfirm>

            </div>

          </template>
        </el-table-column>
      </el-table>
      <!--       <pagi-nation :Count="Count"
                   @size-change="handleSizeChange"
                   @current-change="onCurrentChange"
                   ref="pagination"></pagi-nation> -->
    </div>
    <div class="content"
         v-if="activetab=='add'">
      <div class="formdata">
        <el-form ref="form"
                 :rules="rules"
                 :model="form"
                 label-width="100px"
                 style="width:30%;"
                 size="mini">
          <el-form-item label="标题："
                        prop="title">
            <el-input v-model="form.title"
                      size="mini"></el-input>
          </el-form-item>
                    <el-form-item label="通知类型："
                        prop="type">
            <el-select v-model="form.type"
                       placeholder="请选择">
              <el-option v-for="item in types"
                         :key="item.row_id"
                         :label="item.name"
                         :value="item.row_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行数配置："
                        prop="line">
            <el-input v-model="form.line"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题1："
                        prop="title1">
            <el-input v-model="form.title1"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容1："
                        prop="content1">
            <el-input v-model="form.content1"
                      type="textarea"
                      :rows="4"
                      size="mini"
                      style="width:362px"
                      ></el-input>
          </el-form-item>
          <el-form-item label="标题2："
                        prop="title2">
            <el-input v-model="form.title2"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容2："
                        prop="content2">
            <el-input v-model="form.content2"
                      type="textarea"
                      :rows="4"
                      style="width:362px"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题3："
                        prop="title3">
            <el-input v-model="form.title3"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容3："
                        prop="content3">
            <el-input v-model="form.content3"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题4："
                        prop="title4">
            <el-input v-model="form.title4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容4："
                        prop="content4">
            <el-input v-model="form.content4"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题5："
                        prop="title5">
            <el-input v-model="form.title5"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容5："
                        prop="content5">
            <el-input v-model="form.content5"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="发布时间："
                        prop="publish_date">
            <el-date-picker v-model="form.publish_date"
                            type="date"
                            placeholder="选择结束时间"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button type="primary"
                     size="mini"
                     @click="add()"
                     style="margin-right:20px!important">保存</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="close()">取消</el-button>
        </div>
      </div>
    </div>
    <div class="content"
         v-if="activetab=='edit'">
      <div class="formdata">
        <el-form ref="form2"
                 :rules="rules"
                 :model="form"
                 label-width="100px"
                 style="width:30%;"
                 size="mini">
          <el-form-item label="标题："
                        prop="title">
            <el-input v-model="form.title"
                      size="mini"></el-input>
          </el-form-item>
                    <el-form-item label="通知类型："
                        prop="type">
            <el-select v-model="form.type"
                       placeholder="请选择">
              <el-option v-for="item in types"
                         :key="item.row_id"
                         :label="item.name"
                         :value="item.row_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行数配置："
                        prop="line">
            <el-input v-model="form.line"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题1："
                        prop="title1">
            <el-input v-model="form.title1"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容1："
                        prop="content1">
            <el-input v-model="form.content1"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题2："
                        prop="title2">
            <el-input v-model="form.title2"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容2："
                        prop="content2">
            <el-input v-model="form.content2"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题3："
                        prop="title3">
            <el-input v-model="form.title3"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容3："
                        prop="content3">
            <el-input v-model="form.content3"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题4："
                        prop="title4">
            <el-input v-model="form.title4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容4："
                        prop="content4">
            <el-input v-model="form.content4"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="标题5："
                        prop="title5">
            <el-input v-model="form.title5"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="内容5："
                        prop="content5">
            <el-input v-model="form.content5"
                      type="textarea"
                      style="width:362px"
                      :rows="4"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item label="发布时间："
                        prop="publish_date">
            <el-date-picker v-model="form.publish_date"
                            type="date"
                            placeholder="选择结束时间"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button type="primary"
                     size="mini"
                     @click="edit()"
                     style="margin-right:20px!important">保存</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="close()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagiNation from '@/components/pagiNation'
export default {
  data () {
    return {
      property: 'value',
      tableData: [],
      currentcloumn: [
        {
          title: "标题",
          name: "title"
        },
        {
          title: "通知类型",
          name: "type"
        },
        {
          title: "发布时间",
          name: "publish_date"
        },
      ],
      Count: 0,
      PageSize: 20,
      currentPage: 1,
      loading: false,
      tabDatas: [
        {
          name: "通知管理",
          title: "admin"
        }
      ],
      activetab: "admin",
      form: {},
      types: [
        {
          row_id: "1",
          name: "首页"
        },
        {
          row_id: "2",
          name: "积分商店"
        },
        {
          row_id: "3",
          name: "五大员"
        },
        {
          row_id: "4",
          name: "安管人员"
        },
      ],
      rules: {
        start_time: [
          { required: true, message: '请选择开始时间', trigger: 'blur' },
        ],
        end_time: [
          { required: true, message: '请选择结束时间', trigger: 'blur' },
        ],
      }
    };
  },
  components: {
    pagiNation
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    del (form) {
      console.log('form :>> ', form);
      let params = {
        dataListId: form.row_id
      }
      this.$http.get(this.$Api.recycleNotice, { params }).then((res) => {
        if (res.data.errcode == "0") {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getTableData()
        } else {
          this.$message.error({
            message: '删除失败',
          });
        }
      })
    },
    edit () {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          let params = { data: this.form, dataId: this.form.row_id }
          console.log('params :>> ', params);
          this.$http.get(this.$Api.modifyNotice, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.tabDatas = this.tabDatas.filter(v => v.title !== this.activetab)
              this.activetab = "admin"
              this.getTableData()
            } else {
              this.$message.error({
                message: '修改失败',
              });
            }
          })
        } else {
          return false
        }
      })

    },
    editData (form) {
      this.form = form
      let item = {
        name: form.title + "-编辑",
        title: "edit"
      }
      let list = this.tabDatas.filter(v => v.title == "edit" || v.title == "add")

      if (list.length == 0) {
        this.tabDatas.push(item)
      } else {
        this.tabDatas = this.tabDatas.filter(v => v.title !== "edit" && v.title !== "add")
        this.tabDatas.push(item)
      }
      this.activetab = "edit"
    },
    add () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let params = { data: this.form }
          this.$http.get(this.$Api.addNotice, { params }).then((res) => {
            if (res.data.errcode == "0") {
              this.$message({
                message: '新增成功',
                type: 'success'
              });
              this.tabDatas = this.tabDatas.filter(v => v.title !== this.activetab)
              this.activetab = "admin"
              this.getTableData()
            } else {
              this.$message.error({
                message: '新增失败',
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    close () {
      this.tabDatas = this.tabDatas.filter(v => v.title !== this.activetab)
      this.activetab = "admin"
    },
    handleTabsEdit (a, b) {
      this.tabDatas = this.tabDatas.filter(v => v.title !== a)
      this.activetab = "admin"
    },
    addData () {
      this.form = {}
      let item = {
        name: "新增",
        title: "add"
      }
      let list = this.tabDatas.filter(v => v.title == "add" || v.title == "edit")

      if (list.length == 0) {
        this.tabDatas.push(item)
      } else {
        this.tabDatas = this.tabDatas.filter(v => v.title !== "edit" && v.title !== "add")
        this.tabDatas.push(item)
      }
      this.activetab = "add"
    },
    getTableData () {
      this.loading = true
      let params = {
        pageNo: this.currentPage,
        pageNum: this.PageSize
      }
      this.$http({
        url: this.$Api.getNotice,
        methods: "GET",
        params
      }).then((result) => {
        this.loading = false
        this.Count = result.data.total
        this.tableData = result.data.datalist
      }).catch((err) => {
        this.loading = false
      });
    },
    handleSizeChange (e) {
      console.log("分页器数值改变", e);
      this.PageSize = e;
    },
    onCurrentChange (e) {
      console.log("当前页数值变化", e);
      this.currentPage = e;
    },
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.content {
  background-color: #fff;
  width: 100%;
  height: calc(100vh - 80px);
  .formdata {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
  }
  .buttons {
    display: flex;
    padding-bottom: 40px;
    padding-left: 100px;
  }
}
/deep/.el-table {
  padding: 0 20px;
}
</style>